type SameTabNavigation = Pick<Location, 'assign'>;

export const redirectToHhAuthorization = (
  authUrl: string,
  navigation: SameTabNavigation = window.location
): void => {
  navigation.assign(authUrl);
};
